/* eslint-disable */

import React, { ReactElement } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import { LiveProps } from '../../LiveContainer';
import './LiveGuideline.scss';

export const LiveGuideline = (props: LiveProps): ReactElement => {
  const [numPages, setNumPages] = useState(null);

  const handleClose = () => {
    props.toggleGuidelineModal(false);
    props.toggleSettingsModal(true);
  };

  const onDocumentLoadSuccess = (pdf: any) => {
    setNumPages(pdf.numPages);
  };

  return (
    <Modal
      show={props.liveState.isShowGuidelineModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="live-guideline__modal-dialog"
      contentClassName="live-guideline__modal-content"
      scrollable={true}
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body>
        {/* prettier-ignore */}
        <div className="live-guide__text-content">
          <h3>
            配信の禁止事項
          </h3>
          <hr />
          everylive では配信巡回チームとセキュリティシステムによって、全ての配信をチェックしています。
          <br />
          <br />
          ＜配信停止の対象＞ <br />
          一般ライバー
          
          <pre>
            ・運転中の配信 <br/>
            ・テレビ映像を映すなどの著作権違反 <br/>
            ・カラオケ店舗内の通信カラオケ音源を流す行為<br/>
            ・ライバー自身が 15 歳未満の場合 <br/>
            ・法律や公序良俗に反する内容<br/>
            ・その他、利用規約等に違反する内容<br/>
          </pre>
          オフィシャルライバー
          <pre>
            ・アイコンが配信者の顔または肖像でない配信<br/>
            ・リスナーと交流をしない配信<br/>
            ・寝落ち配信 <br/>
            ・喫煙行為 <br/>
            ・運転中の配信<br/>
            ・テレビ映像を映すなどの著作権違反<br/>
            ・カラオケ店舗内の通信カラオケ音源を流す行為 <br/>
            ・ライバー自身が 15 歳未満の場合 <br/>
            ・法律や公序良俗に反する内容<br/>
            ・その他、利用規約等に違反する内容<br/>
          </pre>
          みなさんが安心して配信を楽しめるよう、ご理解とご協力をお願いいたします。
        </div>
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: 'center' }}>
        <div className="text-center">
          <Button variant="primary" onClick={handleClose}>
            閉じる
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
